export default "__VITE_ASSET__DbJ8o3dV__"